import React from 'react';

import { createIcon } from '@chakra-ui/react';

import { EColor } from '../Theme';

export const MenuIcon = createIcon({
  displayName: 'MenuIcon',
  viewBox: '0 0 24 24',
  path: (
    <g fill="none">
      <rect fill="currentColor" height="2" rx="1" width="18" y="4" />
      <rect fill="currentColor" height="2" rx="1" width="18" y="11" />
      <rect fill="currentColor" height="2" rx="1" width="18" y="18" />
    </g>
  ),
});

export const LogInIcon = createIcon({
  displayName: 'LogInIcon',
  viewBox: '0 0 30 30',
  path: (
    <g fill="none">
      <path
        d="M16.0003 2.66663C8.63653 2.66663 2.66699 8.63616 2.66699 16C2.66699 23.3637 8.63653 29.3333 16.0003 29.3333C23.3641 29.3333 29.3337 23.3637 29.3337 16C29.3337 8.63616 23.3641 2.66663 16.0003 2.66663Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M5.69531 24.4609C5.69531 24.4609 8.66734 20.6666 16.0006 20.6666C23.334 20.6666 26.3061 24.4609 26.3061 24.4609"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M16 16C18.2092 16 20 14.2092 20 12C20 9.79087 18.2092 8 16 8C13.7908 8 12 9.79087 12 12C12 14.2092 13.7908 16 16 16Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  ),
});

export const CloseIcon = createIcon({
  displayName: 'CloseIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M18 6L6 18M6 6l12 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  ),
});

export const RotateImageIcon = createIcon({
  displayName: 'CloseIcon',
  viewBox: '0 0 24 24',
  path: (
    <g
      className=""
      fill="none"
      height="24px"
      width="24px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill={EColor.BrandDark} height="24" width="24" />
      <circle cx="16.5" cy="10.5" r="4" stroke={EColor.BrandLightGray} />
      <path
        d="M13.7879 0.821095C14.6915 0.692002 15.5 1.39319 15.5 2.30602L15.5 21.694C15.5 22.6068 14.6915 23.308 13.7879 23.1789L3.78787 21.7503C3.04889 21.6448 2.5 21.0119 2.5 20.2654L2.5 3.73459C2.5 2.98812 3.04889 2.35523 3.78787 2.24967L13.7879 0.821095Z"
        fill={EColor.BrandDark}
        stroke={EColor.BrandLightGray}
      />
      <rect fill={EColor.BrandDark} height="5" width="3" x="14" y="12" />
      <path
        d="M10 18L7 14.5L10 11"
        stroke={EColor.BrandLightGray}
        strokeLinecap="round"
      />
      <line
        stroke={EColor.BrandLightGray}
        transform="matrix(-1 8.74227e-08 8.74227e-08 1 17 15)"
        x2="10"
        y1="-0.5"
        y2="-0.5"
      />
      <rect fill={EColor.BrandDark} height="10" width="2" x="16" y="3" />
    </g>
  ),
});

export const WeeklyAuctionIcon = createIcon({
  displayName: 'WeeklyAuctionIcon',
  viewBox: '0 0 16 16',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" fill="#008DDF" r="8" />
      <rect
        height="7.57143"
        rx="0.5"
        stroke={EColor.White}
        width="9"
        x="3.5"
        y="4.92859"
      />
      <rect fill={EColor.White} height="2" width="8" x="4" y="5" />
      <rect fill={EColor.White} height="1" rx="0.5" width="1" x="6" y="10" />
      <rect fill={EColor.White} height="1" rx="0.5" width="1" x="8" y="8" />
      <rect fill={EColor.White} height="1" rx="0.5" width="1" x="10" y="8" />
      <rect fill={EColor.White} height="1" rx="0.5" width="1" x="8" y="10" />
      <rect fill={EColor.White} height="1" rx="0.5" width="1" x="10" y="10" />
      <rect fill={EColor.White} height="3" rx="1" width="2" x="4.42871" y="3" />
      <rect fill={EColor.White} height="3" rx="1" width="2" x="9.42871" y="3" />
      <rect
        fill="#008DDF"
        height="1.42857"
        rx="0.357143"
        width="0.714286"
        x="5.14307"
        y="3.71423"
      />
      <rect
        fill="#008DDF"
        height="1.42857"
        rx="0.357143"
        width="0.714286"
        x="10.1431"
        y="3.71423"
      />
    </svg>
  ),
});

export const CalendarIcon = createIcon({
  displayName: 'Calendar',
  viewBox: '0 0 18 18',
  path: (
    <g>
      <g clipPath="url(#prefix__clip0_125:2848)">
        <path
          clipRule="evenodd"
          d="M3.283 1.65c0-.451.366-.817.817-.817h1.633c.451 0 .817.366.817.817V2h4.9v-.35c0-.451.366-.817.817-.817H13.9c.451 0 .817.366.817.817V2h1.633c.451 0 .817.366.817.817V16.35a.817.817 0 01-.817.817H1.65a.817.817 0 01-.817-.817V2.817C.833 2.366 1.2 2 1.65 2h1.633v-.35zM2 16V7.833h14V16H2z"
          fill="#fff"
          fillRule="evenodd"
        />
        <rect
          fill="#fff"
          height={2.333}
          rx={1.167}
          width={2.333}
          x={7.833}
          y={12.5}
        />
        <rect
          fill="#fff"
          height={2.333}
          rx={1.167}
          width={2.333}
          x={7.833}
          y={9}
        />
        <rect
          fill="#fff"
          height={2.333}
          rx={1.167}
          width={2.333}
          x={4.333}
          y={12.5}
        />
        <rect
          fill="#fff"
          height={2.333}
          rx={1.167}
          width={2.333}
          x={11.333}
          y={12.5}
        />
        <rect
          fill="#fff"
          height={2.333}
          rx={1.167}
          width={2.333}
          x={11.333}
          y={9}
        />
        <path
          d="M4.1 1.65h1.633V4.1H4.1zM12.267 1.65H13.9V4.1h-1.633z"
          fill="#000"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_125:2848">
          <path
            d="M0 0h16.333v16.333H0z"
            fill="#fff"
            transform="translate(.833 .833)"
          />
        </clipPath>
      </defs>
    </g>
  ),
});

export const FlashSaleIcon = createIcon({
  displayName: 'FlashSale',
  viewBox: '0 0 24 24',
  path: (
    <g fill="none">
      <circle cx={12} cy={12} fill="#143EE0" r={12} />
      <path
        d="M13 12h1.196L12 15.513V12h1zm-2 0h-1V6h4.382l-2.276 4.553L11.382 12H11z"
        fill="#F9F9F9"
        stroke="#F9F9F9"
        strokeWidth={2}
      />
    </g>
  ),
});

export const PrivateSaleIcon = createIcon({
  displayName: 'PrivateSale',
  viewBox: '0 0 18 18',
  path: (
    <path
      d="M8.32 4.917h2.041l2.24-2.246a.68.68 0 01.966 0l1.756 1.763a.68.68 0 010 .96l-1.559 1.564H8.32V8.32a.68.68 0 11-1.361 0V6.278a1.361 1.361 0 011.36-1.361zM4.236 8.32v2.722L2.678 12.6a.68.68 0 000 .96l1.756 1.762a.68.68 0 00.966 0l2.92-2.92h2.722a.68.68 0 00.68-.68v-.68h.681a.68.68 0 00.68-.68V9.68h.681a.68.68 0 00.68-.68V8.32H9.682V9a1.361 1.361 0 01-1.361 1.361H6.959a1.361 1.361 0 01-1.362-1.36V6.957L4.237 8.32z"
      fill="#fff"
    />
  ),
});

export const PremierAuctionIcon = createIcon({
  displayName: 'PremierAuction',
  viewBox: '0 0 16 16',
  path: (
    <g
      className=""
      fill="none"
      height="40px"
      width="40px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" fill={EColor.BrandDark} r="8" />
      <path
        d="M6 12.9149C6 12.9618 6.03444 13 6.07671 13C6.0955 13 6.11272 12.9931 6.12525 12.9809L9.42231 10.6772C9.77456 10.3749 10 9.90238 10 9.37076V3.08513C10 3.03822 9.96556 3 9.92329 3C9.9045 3 9.88728 3.00695 9.87476 3.01911L6.57769 5.3228C6.22544 5.62509 6 6.09764 6 6.62926V12.9149Z"
        fill="#F9F9F9"
      />
    </g>
  ),
});

export const FixedPriceIcon = createIcon({
  displayName: 'FixedPrice',
  viewBox: '0 0 16 16',
  path: (
    <svg
      className=""
      fill="none"
      height="40px"
      width="40px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" fill="#EE9207" r="8" />
      <rect
        fill={EColor.White}
        height="9"
        rx="1"
        transform="rotate(45 11.4854 4.12109)"
        width="2"
        x="11.4854"
        y="4.12109"
      />
      <path
        d="M7.9502 10.4854L6.53598 11.8996L3.70755 9.07114C3.31703 8.68061 3.31703 8.04745 3.70756 7.65692C4.09808 7.2664 4.73124 7.2664 5.12177 7.65692L7.9502 10.4854Z"
        fill={EColor.White}
      />
    </svg>
  ),
});

export const SelectedIcon = createIcon({
  displayName: 'Selected',
  viewBox: '0 0 20 20',
  path: (
    <g fill="none">
      <rect fill={EColor.BrandDark} height={20} rx={2} width={20} />
      <path
        d="M6 10.39L8.923 14 15 6"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={2}
      />
    </g>
  ),
});

export const SearchIcon = createIcon({
  displayName: 'Search',
  viewBox: '0 0 26 26',
  path: (
    <g fill="none">
      <path
        d="M10.425 18.895a8.47 8.47 0 100-16.94 8.47 8.47 0 000 16.94zm0 1.955C4.667 20.85 0 16.182 0 10.425 0 4.667 4.667 0 10.425 0 16.183 0 20.85 4.667 20.85 10.425c0 5.758-4.668 10.425-10.425 10.425zm8.743.16a1.302 1.302 0 01-.003-1.845 1.296 1.296 0 011.846.003l4.602 4.602c.51.51.515 1.333.002 1.845a1.296 1.296 0 01-1.845-.002l-4.602-4.602z"
        fill={'currentColor' || EColor.BrandDark}
      />
    </g>
  ),
});

export const DownArrowIcon = createIcon({
  displayName: 'DownArrow',
  viewBox: '0 0 56 56',
  path: (
    <g fill="none">
      <rect fill="#fff" height={56} rx={10} width={56} />
      <path
        d="M27.293 33.092a1 1 0 010-1.414l7.778-7.777a1 1 0 011.414 1.414l-7.777 7.777a1 1 0 01-1.415 0z"
        fill={EColor.BrandDark}
      />
      <rect
        fill={EColor.BrandDark}
        height={2}
        rx={1}
        transform="rotate(45 20.221 23.192)"
        width={13.001}
        x={20.221}
        y={23.192}
      />
    </g>
  ),
});

export const GridIcon = createIcon({
  displayName: 'Grid',
  viewBox: '0 0 56 56',
  path: (
    <g fill="none">
      <rect fill="transparent" height={56} rx={10} width={56} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={18} y={27} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={18} y={34} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={36} y={20} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={18} y={20} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={36} y={27} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={36} y={34} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={24} y={20} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={24} y={27} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={24} y={34} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={30} y={20} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={30} y={27} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={30} y={34} />
    </g>
  ),
});

export const TableIcon = createIcon({
  displayName: 'Table',
  viewBox: '0 0 56 56',
  path: (
    <g fill="none">
      <rect fill="transparent" height={56} rx={10} width={56} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={18} y={20} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={18} y={27} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={18} y={34} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={36} y={20} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={36} y={27} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={36} y={34} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={24} y={20} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={24} y={27} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={24} y={34} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={30} y={20} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={30} y={27} />
      <rect fill="currentColor" height={2} rx={1} width={2} x={30} y={34} />
      <path
        d="M25 20h12v2H25zM25 27h12v2H25zM25 34h12v2H25z"
        fill="currentColor"
      />
    </g>
  ),
});

export const BackIcon = createIcon({
  displayName: 'Table',
  viewBox: '0 0 56 56',
  path: (
    <g fill="none">
      <rect
        fillOpacity={0}
        height={56}
        rx={10}
        transform="rotate(90 56 0)"
        width={56}
        x={56}
      />
      <path
        d="M22.908 27.293a1 1 0 011.414 0l7.777 7.778a1 1 0 01-1.414 1.414l-7.777-7.777a1 1 0 010-1.415z"
        fill={EColor.BrandDark}
      />
      <rect
        fill={EColor.BrandDark}
        height={2}
        rx={1}
        transform="rotate(135 32.808 20.221)"
        width={13.001}
        x={32.808}
        y={20.221}
      />
    </g>
  ),
});

export const ScheduleIcon = createIcon({
  viewBox: '0 0 25 26',
  path: (
    <g fill="none">
      <path
        d="M25 0.5H2.63158C1.1782 0.5 0 1.6782 0 3.13158V25.5H22.3684C23.8218 25.5 25 24.3218 25 22.8684V0.5Z"
        fill={EColor.White}
      />
      <path
        d="M25 0.5H2.63C1.17749 0.5 0 1.67749 0 3.13V7.08H25V0.5Z"
        fill="black"
      />
      <path
        d="M7.73204 5.9C7.39171 5.9 7.06556 5.85543 6.75359 5.7663C6.44162 5.67311 6.19042 5.55359 6 5.40774L6.33425 4.6663C6.51657 4.79595 6.73131 4.90332 6.97845 4.9884C7.22965 5.06943 7.48287 5.10994 7.73812 5.10994C7.9326 5.10994 8.08858 5.09171 8.20608 5.05525C8.32762 5.01473 8.41676 4.96004 8.47348 4.89116C8.5302 4.82228 8.55856 4.74328 8.55856 4.65414C8.55856 4.5407 8.514 4.45157 8.42486 4.38674C8.33573 4.31786 8.21823 4.26317 8.07238 4.22265C7.92652 4.17808 7.76446 4.13757 7.58619 4.10111C7.41197 4.06059 7.23573 4.01197 7.05746 3.95525C6.88324 3.89853 6.7232 3.8256 6.57735 3.73646C6.43149 3.64733 6.31197 3.52983 6.21878 3.38398C6.12965 3.23812 6.08508 3.05175 6.08508 2.82486C6.08508 2.58177 6.14991 2.36096 6.27956 2.16243C6.41326 1.95985 6.61179 1.79982 6.87514 1.68232C7.14254 1.56077 7.4768 1.5 7.8779 1.5C8.1453 1.5 8.40866 1.53241 8.66796 1.59724C8.92726 1.65801 9.15617 1.7512 9.3547 1.8768L9.05083 2.62431C8.8523 2.51087 8.65378 2.42781 8.45525 2.37514C8.25672 2.31842 8.06225 2.29006 7.87182 2.29006C7.6814 2.29006 7.52541 2.31234 7.40387 2.35691C7.28232 2.40147 7.19521 2.46022 7.14254 2.53315C7.08987 2.60203 7.06354 2.68306 7.06354 2.77624C7.06354 2.88564 7.1081 2.97477 7.19724 3.04365C7.28637 3.10847 7.40387 3.16114 7.54972 3.20166C7.69558 3.24217 7.85562 3.28269 8.02983 3.3232C8.2081 3.36372 8.38435 3.41031 8.55856 3.46298C8.73683 3.51565 8.8989 3.58656 9.04475 3.67569C9.19061 3.76483 9.3081 3.88232 9.39724 4.02818C9.49042 4.17403 9.53702 4.35838 9.53702 4.58122C9.53702 4.82026 9.47017 5.03904 9.33646 5.23757C9.20276 5.4361 9.00221 5.59613 8.73481 5.71768C8.47145 5.83923 8.1372 5.9 7.73204 5.9Z"
        fill={EColor.White}
      />
      <path
        d="M12.2214 5.9C11.6177 5.9 11.1457 5.73186 10.8053 5.39558C10.465 5.0593 10.2948 4.57919 10.2948 3.95525V1.57293H11.2794V3.91878C11.2794 4.32394 11.3624 4.61565 11.5285 4.79392C11.6946 4.97219 11.9276 5.06133 12.2274 5.06133C12.5272 5.06133 12.7602 4.97219 12.9263 4.79392C13.0924 4.61565 13.1755 4.32394 13.1755 3.91878V1.57293H14.1479V3.95525C14.1479 4.57919 13.9777 5.0593 13.6374 5.39558C13.297 5.73186 12.825 5.9 12.2214 5.9Z"
        fill={EColor.White}
      />
      <path
        d="M15.2423 5.82707V1.57293H16.0567L18.5666 4.63591H18.1716V1.57293H19.144V5.82707H18.3357L15.8197 2.76409H16.2147V5.82707H15.2423Z"
        fill={EColor.White}
      />
      <path
        d="M7.05663 21.5C6.31722 21.5 5.58287 21.4038 4.85359 21.2113C4.12431 21.0087 3.50645 20.7251 3 20.3605L3.95718 18.4765C4.36234 18.7703 4.83333 19.0032 5.37017 19.1754C5.907 19.3476 6.4489 19.4337 6.99586 19.4337C7.61372 19.4337 8.09991 19.3122 8.45442 19.0691C8.80893 18.826 8.98619 18.4917 8.98619 18.0663C8.98619 17.6611 8.82919 17.3421 8.51519 17.1091C8.2012 16.8762 7.69475 16.7597 6.99586 16.7597H5.87155V15.134L8.83425 11.7762L9.10774 12.6575H3.53177V10.6823H10.9765V12.2776L8.02901 15.6354L6.78315 14.9213H7.49724C8.80387 14.9213 9.79144 15.215 10.4599 15.8025C11.1285 16.39 11.4627 17.1446 11.4627 18.0663C11.4627 18.6639 11.3057 19.2261 10.9917 19.7528C10.6777 20.2693 10.1966 20.6897 9.54834 21.0138C8.90009 21.3379 8.06952 21.5 7.05663 21.5Z"
        fill="black"
      />
      <path
        d="M17.461 21.5C16.5899 21.5 15.81 21.2873 15.1212 20.8619C14.4325 20.4263 13.8906 19.7983 13.4955 18.9779C13.1005 18.1575 12.903 17.1648 12.903 16C12.903 14.8352 13.1005 13.8425 13.4955 13.0221C13.8906 12.2017 14.4325 11.5787 15.1212 11.1533C15.81 10.7178 16.5899 10.5 17.461 10.5C18.3422 10.5 19.1221 10.7178 19.8008 11.1533C20.4895 11.5787 21.0314 12.2017 21.4265 13.0221C21.8215 13.8425 22.019 14.8352 22.019 16C22.019 17.1648 21.8215 18.1575 21.4265 18.9779C21.0314 19.7983 20.4895 20.4263 19.8008 20.8619C19.1221 21.2873 18.3422 21.5 17.461 21.5ZM17.461 19.4185C17.8763 19.4185 18.2359 19.302 18.5397 19.0691C18.8537 18.8361 19.0968 18.4664 19.269 17.9599C19.4513 17.4535 19.5425 16.8002 19.5425 16C19.5425 15.1998 19.4513 14.5465 19.269 14.0401C19.0968 13.5336 18.8537 13.1639 18.5397 12.9309C18.2359 12.698 17.8763 12.5815 17.461 12.5815C17.0558 12.5815 16.6963 12.698 16.3823 12.9309C16.0784 13.1639 15.8353 13.5336 15.653 14.0401C15.4808 14.5465 15.3947 15.1998 15.3947 16C15.3947 16.8002 15.4808 17.4535 15.653 17.9599C15.8353 18.4664 16.0784 18.8361 16.3823 19.0691C16.6963 19.302 17.0558 19.4185 17.461 19.4185Z"
        fill="black"
      />
    </g>
  ),
});

export const ThinChevronRight = createIcon({
  viewBox: '0 0 15 8',
  path: (
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.2 7.663a.72.72 0 0 1-1.028 0L.516 1.925a.745.745 0 0 1 0-1.044.72.72 0 0 1 1.028 0L7.2 6.62a.745.745 0 0 1 0 1.043Z"
        fill="currentColor"
      />
      <rect
        fill="currentColor"
        height="1.465"
        rx=".733"
        transform="matrix(.70198 -.7122 .70198 .7122 0 12.881)"
        width="9.524"
      />
    </g>
  ),
});

export const ClearSearch = createIcon({
  viewBox: '0 0 38 24',
  path: (
    <g>
      <mask fill={EColor.White} id="path-1-inside-1_1248_32072">
        <path d="M36.4527 23.0049H11.345C11.0713 23.0056 10.8088 22.8955 10.6149 22.6997L0.302836 12.2444C0.108977 12.0482 0 11.782 0 11.5042C0 11.2263 0.108977 10.9601 0.302836 10.7639L10.6149 0.308675C10.8088 0.112854 11.0713 0.00273773 11.345 0.00346586H36.4527C36.726 0.00346586 36.9882 0.113591 37.1817 0.309767C37.3752 0.505588 37.4838 0.771777 37.4838 1.04892V21.9594C37.4838 22.2366 37.3752 22.5028 37.1817 22.6986C36.9882 22.8948 36.726 23.0049 36.4527 23.0049Z" />
      </mask>
      <path
        d="M11.345 23.0049L11.3424 22.0049H11.345V23.0049ZM10.6149 22.6997L9.90428 23.4032L9.90296 23.4019L10.6149 22.6997ZM0.302836 12.2444L1.01415 11.5415L1.0148 11.5422L0.302836 12.2444ZM0.302836 10.7639L1.0148 11.4661L1.01415 11.4668L0.302836 10.7639ZM10.6149 0.308676L9.90296 -0.393541L9.90427 -0.394861L10.6149 0.308676ZM11.345 0.00346565V1.00347L11.3424 1.00346L11.345 0.00346565ZM37.1817 0.309767L36.4704 1.01264L36.4697 1.012L37.1817 0.309767ZM37.1817 22.6986L36.4697 21.9964L36.4704 21.9957L37.1817 22.6986ZM36.4527 24.0049H11.345V22.0049H36.4527V24.0049ZM11.3477 24.0049C10.8027 24.0063 10.2842 23.7869 9.90428 23.4032L11.3256 21.9961C11.3334 22.004 11.34 22.0049 11.3424 22.0049L11.3477 24.0049ZM9.90296 23.4019L-0.409129 12.9466L1.0148 11.5422L11.3269 21.9975L9.90296 23.4019ZM-0.408478 12.9473C-0.788633 12.5626 -1 12.0433 -1 11.5042H1C1 11.5208 1.00659 11.5339 1.01415 11.5415L-0.408478 12.9473ZM-1 11.5042C-1 10.9651 -0.788631 10.4458 -0.408478 10.0611L1.01415 11.4668C1.00659 11.4745 1 11.4875 1 11.5042H-1ZM-0.409129 10.0617L9.90296 -0.393541L11.3269 1.01089L1.0148 11.4661L-0.409129 10.0617ZM9.90427 -0.394861C10.2842 -0.778605 10.8027 -0.99798 11.3477 -0.996531L11.3424 1.00346C11.34 1.00346 11.3334 1.00431 11.3256 1.01221L9.90427 -0.394861ZM11.345 -0.996534H36.4527V1.00347H11.345V-0.996534ZM36.4527 -0.996534C36.9959 -0.996534 37.5138 -0.777517 37.8936 -0.392466L36.4697 1.012C36.4625 1.0047 36.4561 1.00347 36.4527 1.00347V-0.996534ZM37.893 -0.39311C38.2734 -0.00818825 38.4838 0.511335 38.4838 1.04892H36.4838C36.4838 1.03222 36.477 1.01937 36.4704 1.01264L37.893 -0.39311ZM38.4838 1.04892V21.9594H36.4838V1.04892H38.4838ZM38.4838 21.9594C38.4838 22.497 38.2733 23.0165 37.893 23.4014L36.4704 21.9957C36.477 21.989 36.4838 21.9761 36.4838 21.9594H38.4838ZM37.8937 23.4008C37.5138 23.7859 36.9959 24.0049 36.4527 24.0049V22.0049C36.4561 22.0049 36.4625 22.0036 36.4697 21.9964L37.8937 23.4008Z"
        fill="#2D2D2D"
        mask="url(#path-1-inside-1_1248_32072)"
      />
      <rect
        fill={EColor.BrandDark}
        height="2"
        rx="1"
        transform="rotate(45 20.792 4.9502)"
        width="16"
        x="20.792"
        y="4.9502"
      />
      <rect
        fill={EColor.BrandDark}
        height="2"
        rx="1"
        transform="rotate(135 32.1064 6.36426)"
        width="16"
        x="32.1064"
        y="6.36426"
      />
    </g>
  ),
});

export const DeleteIcon = createIcon({
  viewBox: '0 0 20 20',
  path: (
    <g fill="none" height="20" width="20">
      <rect fill={EColor.White} height="20" width="20" />
      <path
        d="M2.5 4.5H17.5V18C17.5 18.8284 16.8284 19.5 16 19.5H4C3.17157 19.5 2.5 18.8284 2.5 18V4.5Z"
        stroke="currentColor"
      />
      <rect fill="currentColor" height="8" rx="0.5" width="1" x="9.5" y="8" />
      <rect fill="currentColor" height="8" rx="0.5" width="1" x="6" y="8" />
      <rect fill="currentColor" height="8" rx="0.5" width="1" x="13" y="8" />
      <rect fill="currentColor" height="1" rx="0.5" width="20" y="4" />
      <path
        d="M7.32951 0.901943C7.37626 0.66823 7.58146 0.5 7.8198 0.5H12.1802C12.4185 0.5 12.6237 0.66823 12.6705 0.901942L13.3901 4.5H6.6099L7.32951 0.901943Z"
        stroke="currentColor"
      />
    </g>
  ),
});

export const CloseCircleIcon = createIcon({
  viewBox: '0 0 20 20',
  path: (
    <g fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect fill="currentColor" height="20" rx="10" width="20" />
      <path
        clipRule="evenodd"
        d="M6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L8.58579 10L5.29289 13.2929C4.90237 13.6834 4.90237 14.3166 5.29289 14.7071C5.68342 15.0976 6.31658 15.0976 6.70711 14.7071L10 11.4142L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L11.4142 10L14.7071 6.70711C15.0976 6.31658 15.0976 5.68342 14.7071 5.29289C14.3166 4.90237 13.6834 4.90237 13.2929 5.29289L10 8.58579L6.70711 5.29289Z"
        fill={EColor.White}
        fillRule="evenodd"
      />
    </g>
  ),
});

export const GraphUpIcon = createIcon({
  viewBox: '0 0 28 28',
  path: (
    <g fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect fill={EColor.Neutral5} height="28" rx="5" width="28" />
      <path
        d="M19 4.26782H24V9.26782"
        stroke={EColor.BrandDark}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M23 5L15.6111 15.3889L11.3889 12.5556L4 22"
        stroke={EColor.BrandDark}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  ),
});

export const ArrowRightSquareIcon = createIcon({
  viewBox: '0 0 20 20',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect fill={EColor.Neutral5} height="20" rx="2" width="20" />
      <path
        clipRule="evenodd"
        d="M11.7071 4.29289C11.3166 3.90237 10.6834 3.90237 10.2929 4.29289C9.90237 4.68342 9.90237 5.31658 10.2929 5.70711L13.5858 9H3C2.44772 9 2 9.44772 2 10C2 10.5523 2.44772 11 3 11H13.5858L10.2929 14.2929C9.90237 14.6834 9.90237 15.3166 10.2929 15.7071C10.6834 16.0976 11.3166 16.0976 11.7071 15.7071L16.7065 10.7077C16.7069 10.7073 16.7073 10.707 16.7076 10.7066L17.4142 10L16.7076 9.29342C16.7073 9.29304 16.7069 9.29265 16.7065 9.29226L11.7071 4.29289Z"
        fill={EColor.BrandDark}
        fillRule="evenodd"
      />
    </svg>
  ),
});

export const MagnifyingGlass = createIcon({
  viewBox: '0 0 24 24',
  path: (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 17L21 21"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M3 11C3 15.4183 6.58172 19 11 19C13.213 19 15.2161 18.1015 16.6644 16.6493C18.1077 15.2022 19 13.2053 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  ),
});

export const CopyIcon = createIcon({
  viewBox: '0 0 16 16',
  path: (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9333 13.3333H6.4C6.17909 13.3333 6 13.1543 6 12.9333V6.4C6 6.17909 6.17909 6 6.4 6H12.9333C13.1543 6 13.3333 6.17909 13.3333 6.4V12.9333C13.3333 13.1543 13.1543 13.3333 12.9333 13.3333Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M9.99996 6.00008V3.06675C9.99996 2.84583 9.82089 2.66675 9.59996 2.66675H3.06663C2.84571 2.66675 2.66663 2.84583 2.66663 3.06675V9.60008C2.66663 9.82101 2.84571 10.0001 3.06663 10.0001H5.99996"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </svg>
  ),
});

export const ClockIconSquare = createIcon({
  viewBox: '0 0 28 28',
  path: (
    <g fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect fill={EColor.Neutral5} height="28" rx="5" width="28" />
      <path
        clipRule="evenodd"
        d="M20 14C20 17.3137 17.3137 20 14 20C10.6863 20 8 17.3137 8 14C8 10.6863 10.6863 8 14 8C17.3137 8 20 10.6863 20 14ZM22 14C22 18.4183 18.4183 22 14 22C9.58172 22 6 18.4183 6 14C6 9.58172 9.58172 6 14 6C18.4183 6 22 9.58172 22 14ZM15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V14C13 14.2652 13.1054 14.5196 13.2929 14.7071L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L15 13.5858V11Z"
        fill={EColor.BrandDark}
        fillRule="evenodd"
      />
    </g>
  ),
});

export const UnionIcon = createIcon({
  viewBox: '0 0 14 12',
  path: (
    <svg
      fill="none"
      height="11"
      viewBox="0 0 11 11"
      width="11"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M0.242186 8.19974C0.242187 8.75202 0.689902 9.19974 1.24219 9.19974C1.79447 9.19974 2.24219 8.75202 2.24219 8.19974L2.24219 3.6141L8.535 9.90692C8.92553 10.2974 9.55869 10.2974 9.94922 9.90692C10.3397 9.5164 10.3397 8.88323 9.94922 8.49271L3.58518 2.12867L8.31325 2.12867C8.86554 2.12867 9.31325 1.68096 9.31325 1.12867C9.31325 0.576386 8.86554 0.12867 8.31325 0.128671L1.24219 0.128672L0.242186 0.128671L0.242187 1.12867L0.242187 1.18754C0.242087 1.19572 0.242087 1.20391 0.242187 1.21209L0.242186 8.19974Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
});

export const InstagramIcon = createIcon({
  viewBox: '0 0 17 17',
  path: (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 17 17"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M5 1.66667C3.15905 1.66667 1.66667 3.15905 1.66667 5V11.6667C1.66667 13.5076 3.15905 15 5 15H11.6667C13.5076 15 15 13.5076 15 11.6667V5C15 3.15905 13.5076 1.66667 11.6667 1.66667H5ZM0 5C0 2.23858 2.23858 0 5 0H11.6667C14.4281 0 16.6667 2.23858 16.6667 5V11.6667C16.6667 14.4281 14.4281 16.6667 11.6667 16.6667H5C2.23858 16.6667 0 14.4281 0 11.6667V5ZM13.4825 3.12967C13.8246 3.43756 13.8523 3.96447 13.5444 4.30655L13.5361 4.31581C13.2282 4.6579 12.7013 4.68562 12.3592 4.37774C12.0171 4.06985 11.9894 3.54294 12.2973 3.20085L12.3056 3.19159C12.6135 2.84951 13.1404 2.82178 13.4825 3.12967ZM8.33333 5.83333C6.95262 5.83333 5.83333 6.95262 5.83333 8.33333C5.83333 9.71405 6.95262 10.8333 8.33333 10.8333C9.71405 10.8333 10.8333 9.71405 10.8333 8.33333C10.8333 6.95262 9.71405 5.83333 8.33333 5.83333ZM4.16667 8.33333C4.16667 6.03215 6.03215 4.16667 8.33333 4.16667C10.6345 4.16667 12.5 6.03215 12.5 8.33333C12.5 10.6345 10.6345 12.5 8.33333 12.5C6.03215 12.5 4.16667 10.6345 4.16667 8.33333Z"
        fill="#222326"
        fillRule="evenodd"
      />
    </svg>
  ),
});

export const YoutubeIcon = createIcon({
  viewBox: '0 0 18 14',
  path: (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 18 14"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M8.95833 0C9.95105 0 11.1078 0.0226049 12.2363 0.0545247L12.2819 0.0561523C13.4309 0.0886331 14.3575 0.115211 15.0879 0.236003C15.8484 0.361778 16.4798 0.601843 16.9849 1.12142C17.4913 1.64241 17.7127 2.2866 17.8166 3.05745C17.9165 3.7994 17.9167 4.73903 17.9167 5.90658V7.17692C17.9167 8.34451 17.9165 9.28409 17.8166 10.026C17.7127 10.7969 17.4913 11.4411 16.9849 11.9621C16.4798 12.4816 15.8483 12.7217 15.0879 12.8475C14.3575 12.9683 13.4309 12.9949 12.2819 13.0273L12.2363 13.0282C11.1077 13.0601 9.95107 13.0835 8.95833 13.0835C7.96559 13.0835 6.80892 13.0601 5.68034 13.0282L5.63477 13.0273C4.48576 12.9949 3.55919 12.9683 2.82878 12.8475C2.06832 12.7217 1.43689 12.4816 0.931804 11.9621C0.425346 11.4411 0.203934 10.7969 0.100098 10.026C0.000162398 9.28408 -1.64855e-05 8.34452 3.52218e-07 7.17692V5.90658C-1.64846e-05 4.73902 0.000176914 3.7994 0.100098 3.05745C0.203935 2.2866 0.425349 1.64241 0.931804 1.12142C1.43689 0.601843 2.06831 0.361778 2.82878 0.236003C3.5592 0.115211 4.48576 0.0886331 5.63477 0.0561523L5.68034 0.0545247C6.80889 0.0226049 7.96562 1.28264e-08 8.95833 0ZM8.01839 4.33187C7.82504 4.22142 7.58765 4.22262 7.39502 4.33431C7.20232 4.44614 7.08333 4.65188 7.08333 4.87467V8.20801C7.08333 8.4308 7.20232 8.63655 7.39502 8.74837C7.58765 8.86006 7.82504 8.86126 8.01839 8.75081L10.9351 7.08415C11.1298 6.97287 11.25 6.76563 11.25 6.54134C11.25 6.31706 11.1298 6.10981 10.9351 5.99854L8.01839 4.33187Z"
        fill="#222326"
        fillRule="evenodd"
      />
    </svg>
  ),
});

export const TiktokIcon = createIcon({
  viewBox: '0 0 15 17',
  path: (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 15 17"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4608 0H7.79545V11.3217C7.79545 12.8077 6.72815 13.7629 5.43087 13.7629C4.13359 13.7629 2.98374 12.8077 2.98374 11.3217C2.98374 9.60574 4.32229 8.70354 6.10899 8.89224V6.02644C5.84954 5.98516 5.59008 5.96747 5.3719 5.96747C2.44714 5.96747 0 8.31436 0 11.2273C0 14.3113 2.41765 16.67 5.38959 16.67C7.99594 16.67 10.7615 14.7536 10.7615 11.1389V5.24807C11.9114 6.39793 13.3089 6.75763 14.8066 6.75763V4.11001C12.9669 3.97438 10.9266 2.76556 10.4608 0Z"
        fill="#222326"
      />
    </svg>
  ),
});

export const FacebookIcon = createIcon({
  viewBox: '0 0 10 17',
  path: (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 10 17"
      width="10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.39456 9.35394L8.95572 6.2981H5.68936V5.21734C5.68936 3.60247 6.32288 2.98139 7.9626 2.98139C8.47192 2.98139 8.88184 2.99379 9.11788 3.01863V0.24851C8.67068 0.124269 7.57752 2.86102e-05 6.944 2.86102e-05C3.60244 2.86102e-05 2.06208 1.57767 2.06208 4.98135V6.2981H0V9.35394H2.06208V16.0036C2.8358 16.1955 3.6448 16.2981 4.47784 16.2981C4.888 16.2981 5.29216 16.2728 5.68936 16.2249V9.35394H8.39456Z"
        fill="#222326"
      />
    </svg>
  ),
});

export const TwitterIcon = createIcon({
  viewBox: '0 0 16 17',
  path: (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 16 17"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M15.0338 0.210501C15.3778 0.516266 15.4088 1.04299 15.103 1.38698L9.78574 7.36889L15.3436 14.5148C16.0248 15.3906 15.4007 16.6667 14.2912 16.6667H12.2247C11.8132 16.6667 11.4248 16.4767 11.1722 16.1519L6.88186 10.6358L1.76966 16.387C1.46389 16.731 0.937165 16.7619 0.593179 16.4562C0.249194 16.1504 0.21821 15.6237 0.523975 15.2797L5.84123 9.2978L0.283332 2.15193C-0.397854 1.27612 0.226271 8.93056e-06 1.3358 8.93056e-06H3.40227C3.81373 8.93056e-06 4.20214 0.189973 4.45474 0.514755L8.7451 6.03093L13.8573 0.279706C14.1631 -0.0642799 14.6898 -0.0952638 15.0338 0.210501ZM7.619 7.2978L3.23925 1.66668H2.01735L6.96733 8.03093L7.619 7.2978ZM8.00796 9.36889L12.3877 15H13.6096L8.65964 8.63575L8.00796 9.36889Z"
        fill="#222326"
        fillRule="evenodd"
      />
    </svg>
  ),
});

export const LinkedinIcon = createIcon({
  viewBox: '0 0 24 24',
  path: (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z"
        stroke="#4A4C4C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M7 17V13.5V10"
        stroke="#4A4C4C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M11 17V13.75M11 13.75V10M11 13.75C11 10 17 10 17 13.75V17"
        stroke="#4A4C4C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M7 7.01001L7.01 6.9989"
        stroke="#4A4C4C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  ),
});

export const AppstoreIcon = createIcon({
  viewBox: '0 0 120 40',
  path: (
    <svg
      fill="none"
      height="40"
      viewBox="0 0 120 40"
      width="120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M110.135 0.00013H9.53468C9.16798 0.00013 8.80568 0.00013 8.43995 0.00213C8.1338 0.00413 7.83009 0.00994 7.521 0.01483C6.84951 0.0227318 6.17961 0.0818063 5.5171 0.19154C4.85552 0.303663 4.21467 0.515046 3.61622 0.81854C3.0185 1.1246 2.47235 1.5223 1.99757 1.9972C1.5203 2.47077 1.12246 3.01815 0.81935 3.61829C0.5154 4.21724 0.304641 4.85907 0.19435 5.52161C0.0830109 6.18332 0.0230984 6.85265 0.01515 7.52361C0.00587 7.83021 0.00489 8.13783 0 8.44447V31.5587C0.00489 31.8692 0.00587 32.17 0.01515 32.4806C0.0231008 33.1516 0.0830134 33.8209 0.19435 34.4825C0.304336 35.1455 0.515108 35.7877 0.81935 36.3868C1.12233 36.985 1.52022 37.5302 1.99757 38.0011C2.47054 38.4781 3.01705 38.8761 3.61622 39.1798C4.21467 39.4841 4.85545 39.6968 5.5171 39.8106C6.17972 39.9195 6.84956 39.9786 7.521 39.9874C7.83009 39.9942 8.1338 39.9981 8.43995 39.9981C8.80567 40.0001 9.168 40.0001 9.53468 40.0001H110.135C110.494 40.0001 110.859 40.0001 111.219 39.9981C111.523 39.9981 111.836 39.9942 112.141 39.9874C112.811 39.9791 113.479 39.92 114.141 39.8106C114.804 39.696 115.448 39.4834 116.049 39.1798C116.647 38.8759 117.193 38.478 117.666 38.0011C118.142 37.5284 118.541 36.9836 118.848 36.3868C119.15 35.7872 119.358 35.1451 119.467 34.4825C119.578 33.8208 119.64 33.1516 119.652 32.4806C119.656 32.17 119.656 31.8692 119.656 31.5587C119.664 31.1954 119.664 30.8341 119.664 30.4649V9.53626C119.664 9.17005 119.664 8.80677 119.656 8.44447C119.656 8.13783 119.656 7.83021 119.652 7.52357C119.64 6.85255 119.578 6.18337 119.467 5.52157C119.358 4.85941 119.149 4.21763 118.848 3.61825C118.23 2.41533 117.252 1.43616 116.049 0.81845C115.448 0.515697 114.804 0.30437 114.141 0.19145C113.48 0.0812328 112.811 0.0221378 112.141 0.01469C111.836 0.00981 111.523 0.00395 111.219 0.002C110.859 0 110.494 0.00013 110.135 0.00013Z"
        fill="#A6A6A6"
      />
      <path
        d="M8.44487 39.125C8.14019 39.125 7.84287 39.1211 7.54058 39.1143C6.91436 39.1061 6.2896 39.0516 5.67144 38.9512C5.09503 38.8519 4.53664 38.6673 4.0147 38.4033C3.49754 38.1415 3.02585 37.7983 2.6177 37.3867C2.20364 36.98 1.85891 36.5082 1.59719 35.9902C1.33258 35.4688 1.14945 34.9099 1.05419 34.333C0.951311 33.7131 0.895651 33.0863 0.887687 32.458C0.881347 32.2471 0.873047 31.5449 0.873047 31.5449V8.44434C0.873047 8.44434 0.881887 7.75293 0.887737 7.5498C0.895363 6.92248 0.950699 6.29665 1.05327 5.67773C1.14871 5.09925 1.33197 4.53875 1.59673 4.01563C1.85749 3.49794 2.2003 3.02586 2.61187 2.61768C3.02297 2.20562 3.49617 1.8606 4.01421 1.59521C4.53495 1.33209 5.09228 1.14873 5.66753 1.05127C6.28772 0.949836 6.91465 0.894996 7.54304 0.88721L8.44536 0.875H111.214L112.127 0.8877C112.75 0.895099 113.371 0.94945 113.985 1.05029C114.566 1.14898 115.13 1.33362 115.656 1.59814C116.694 2.13299 117.539 2.97916 118.071 4.01807C118.332 4.53758 118.512 5.09351 118.607 5.66699C118.71 6.29099 118.768 6.92174 118.78 7.5542C118.783 7.8374 118.783 8.1416 118.783 8.44434C118.791 8.81934 118.791 9.17627 118.791 9.53613V30.4648C118.791 30.8281 118.791 31.1826 118.783 31.54C118.783 31.8652 118.783 32.1631 118.779 32.4697C118.768 33.0909 118.711 33.7104 118.608 34.3232C118.515 34.9043 118.333 35.4675 118.068 35.9932C117.805 36.5056 117.462 36.9733 117.053 37.3789C116.644 37.7927 116.172 38.1379 115.653 38.4014C115.128 38.6674 114.566 38.8527 113.985 38.9512C113.367 39.0522 112.742 39.1067 112.116 39.1143C111.823 39.1211 111.517 39.125 111.219 39.125L110.135 39.127L8.44487 39.125Z"
        fill="black"
      />
      <path
        d="M42.3027 27.1397H37.5693L36.4326 30.4962H34.4277L38.9111 18.0782H40.9941L45.4775 30.4962H43.4385L42.3027 27.1397ZM38.0596 25.5909H41.8116L39.962 20.1436H39.9102L38.0596 25.5909Z"
        fill="white"
      />
      <path
        d="M55.1602 25.9698C55.1602 28.7833 53.6543 30.5909 51.3818 30.5909C50.8062 30.621 50.2337 30.4884 49.7299 30.2082C49.2261 29.9281 48.8114 29.5118 48.5332 29.0069H48.4902V33.4913H46.6318V21.4424H48.4307V22.9483H48.4648C48.7558 22.4458 49.1775 22.0316 49.6852 21.7498C50.1928 21.4679 50.7673 21.329 51.3477 21.3477C53.6455 21.3477 55.1602 23.1641 55.1602 25.9698ZM53.25 25.9698C53.25 24.1368 52.3027 22.9317 50.8574 22.9317C49.4375 22.9317 48.4824 24.1622 48.4824 25.9698C48.4824 27.794 49.4375 29.0157 50.8574 29.0157C52.3027 29.0157 53.25 27.8194 53.25 25.9698Z"
        fill="white"
      />
      <path
        d="M65.125 25.9698C65.125 28.7833 63.6191 30.5909 61.3467 30.5909C60.771 30.621 60.1985 30.4884 59.6947 30.2082C59.1909 29.9281 58.7762 29.5118 58.498 29.0069H58.455V33.4913H56.5966V21.4424H58.3955V22.9483H58.4296C58.7206 22.4458 59.1423 22.0316 59.65 21.7498C60.1576 21.468 60.7321 21.329 61.3125 21.3477C63.6103 21.3477 65.125 23.1641 65.125 25.9698ZM63.2148 25.9698C63.2148 24.1368 62.2676 22.9317 60.8223 22.9317C59.4023 22.9317 58.4473 24.1622 58.4473 25.9698C58.4473 27.794 59.4023 29.0157 60.8223 29.0157C62.2676 29.0157 63.2148 27.8194 63.2148 25.9698Z"
        fill="white"
      />
      <path
        d="M71.7109 27.0362C71.8486 28.2676 73.0449 29.0762 74.6797 29.0762C76.2461 29.0762 77.373 28.2676 77.373 27.1572C77.373 26.1934 76.6934 25.6162 75.084 25.2207L73.4746 24.833C71.1943 24.2822 70.1357 23.2158 70.1357 21.4854C70.1357 19.3428 72.0029 17.8711 74.6543 17.8711C77.2783 17.8711 79.0771 19.3428 79.1377 21.4854H77.2617C77.1494 20.2461 76.125 19.4981 74.6279 19.4981C73.1308 19.4981 72.1064 20.2549 72.1064 21.3565C72.1064 22.2344 72.7607 22.751 74.3613 23.1465L75.7295 23.4824C78.2773 24.0849 79.3359 25.1084 79.3359 26.9248C79.3359 29.248 77.4853 30.7031 74.542 30.7031C71.7881 30.7031 69.9287 29.2822 69.8086 27.0361L71.7109 27.0362Z"
        fill="white"
      />
      <path
        d="M83.3467 19.2999V21.4424H85.0684V22.9141H83.3467V27.9053C83.3467 28.6807 83.6914 29.042 84.4482 29.042C84.6526 29.0385 84.8567 29.0241 85.0596 28.999V30.4619C84.7193 30.5255 84.3734 30.5543 84.0273 30.5479C82.1943 30.5479 81.4795 29.8594 81.4795 28.1035V22.9141H80.1631V21.4424H81.4795V19.2999H83.3467Z"
        fill="white"
      />
      <path
        d="M86.0655 25.9698C86.0655 23.1212 87.7432 21.3311 90.3594 21.3311C92.9844 21.3311 94.6543 23.1211 94.6543 25.9698C94.6543 28.8262 92.9932 30.6085 90.3594 30.6085C87.7266 30.6085 86.0655 28.8262 86.0655 25.9698ZM92.7608 25.9698C92.7608 24.0157 91.8653 22.8624 90.3594 22.8624C88.8535 22.8624 87.959 24.0245 87.959 25.9698C87.959 27.9317 88.8535 29.0762 90.3594 29.0762C91.8653 29.0762 92.7608 27.9317 92.7608 25.9698Z"
        fill="white"
      />
      <path
        d="M96.1865 21.4424H97.959V22.9834H98.002C98.1219 22.5021 98.4039 22.0768 98.8004 21.7789C99.197 21.481 99.6841 21.3288 100.18 21.3477C100.394 21.3469 100.607 21.3702 100.816 21.417V23.1553C100.546 23.0727 100.264 23.0348 99.9814 23.043C99.7115 23.0321 99.4423 23.0797 99.1925 23.1825C98.9426 23.2854 98.718 23.4412 98.534 23.6391C98.3501 23.8369 98.2111 24.0723 98.1267 24.329C98.0422 24.5856 98.0143 24.8575 98.0449 25.126V30.4961H96.1865L96.1865 21.4424Z"
        fill="white"
      />
      <path
        d="M109.385 27.837C109.135 29.4805 107.534 30.6084 105.486 30.6084C102.853 30.6084 101.218 28.8438 101.218 26.0127C101.218 23.1729 102.861 21.3311 105.408 21.3311C107.913 21.3311 109.488 23.0518 109.488 25.7969V26.4336H103.094V26.5459C103.064 26.8791 103.106 27.2148 103.216 27.5307C103.326 27.8465 103.502 28.1353 103.733 28.3778C103.963 28.6204 104.242 28.8111 104.552 28.9374C104.862 29.0637 105.195 29.1227 105.529 29.1104C105.968 29.1515 106.409 29.0498 106.786 28.8204C107.163 28.591 107.455 28.246 107.62 27.837L109.385 27.837ZM103.103 25.1348H107.629C107.646 24.8352 107.6 24.5354 107.495 24.2542C107.391 23.973 107.229 23.7165 107.021 23.5007C106.812 23.2849 106.561 23.1146 106.284 23.0004C106.006 22.8861 105.708 22.8305 105.408 22.837C105.106 22.8352 104.806 22.8933 104.526 23.008C104.245 23.1228 103.991 23.2919 103.777 23.5055C103.562 23.7191 103.392 23.9731 103.277 24.2527C103.161 24.5324 103.102 24.8322 103.103 25.1348Z"
        fill="white"
      />
      <path
        d="M37.8262 8.73101C38.2158 8.70305 38.6067 8.76191 38.9709 8.90334C39.335 9.04478 39.6632 9.26526 39.9317 9.54888C40.2003 9.83251 40.4026 10.1722 40.524 10.5435C40.6454 10.9147 40.6829 11.3083 40.6338 11.6959C40.6338 13.6021 39.6035 14.6979 37.8262 14.6979H35.6709V8.73101H37.8262ZM36.5976 13.854H37.7226C38.0011 13.8707 38.2797 13.825 38.5382 13.7204C38.7967 13.6158 39.0287 13.4548 39.2172 13.2493C39.4057 13.0437 39.546 12.7987 39.6278 12.5321C39.7097 12.2655 39.7311 11.9839 39.6904 11.708C39.7281 11.4332 39.7046 11.1534 39.6215 10.8887C39.5383 10.6241 39.3977 10.3811 39.2096 10.1771C39.0216 9.97321 38.7907 9.81341 38.5337 9.70917C38.2766 9.60493 37.9996 9.55885 37.7226 9.57422H36.5976V13.854Z"
        fill="white"
      />
      <path
        d="M41.6807 12.4444C41.6523 12.1484 41.6862 11.8499 41.78 11.5678C41.8739 11.2857 42.0256 11.0264 42.2256 10.8064C42.4255 10.5864 42.6692 10.4107 42.9411 10.2904C43.2129 10.1701 43.5069 10.108 43.8042 10.108C44.1015 10.108 44.3955 10.1701 44.6673 10.2904C44.9392 10.4107 45.1829 10.5864 45.3828 10.8064C45.5827 11.0264 45.7345 11.2857 45.8283 11.5678C45.9222 11.8499 45.956 12.1484 45.9277 12.4444C45.9566 12.7406 45.9231 13.0396 45.8295 13.3221C45.7359 13.6046 45.5843 13.8644 45.3843 14.0848C45.1843 14.3053 44.9404 14.4814 44.6683 14.6019C44.3961 14.7225 44.1018 14.7847 43.8042 14.7847C43.5066 14.7847 43.2122 14.7225 42.9401 14.6019C42.668 14.4814 42.4241 14.3053 42.2241 14.0848C42.0241 13.8644 41.8724 13.6046 41.7789 13.3221C41.6853 13.0396 41.6518 12.7406 41.6807 12.4444ZM45.0137 12.4444C45.0137 11.4683 44.5752 10.8975 43.8057 10.8975C43.0332 10.8975 42.5987 11.4683 42.5987 12.4444C42.5987 13.4283 43.0332 13.9947 43.8057 13.9947C44.5752 13.9946 45.0137 13.4243 45.0137 12.4444Z"
        fill="white"
      />
      <path
        d="M51.5732 14.6978H50.6514L49.7207 11.3814H49.6504L48.7236 14.6978H47.8105L46.5693 10.1948H47.4707L48.2773 13.6308H48.3438L49.2695 10.1948H50.1221L51.0479 13.6308H51.1182L51.9209 10.1948H52.8096L51.5732 14.6978Z"
        fill="white"
      />
      <path
        d="M53.8535 10.1948H54.709V10.9102H54.7754C54.888 10.6532 55.078 10.4379 55.3189 10.2941C55.5598 10.1503 55.8395 10.0852 56.1191 10.1079C56.3382 10.0914 56.5582 10.1245 56.7628 10.2046C56.9674 10.2847 57.1514 10.4098 57.3011 10.5706C57.4508 10.7315 57.5623 10.9239 57.6275 11.1337C57.6927 11.3436 57.7099 11.5654 57.6777 11.7827V14.6977H56.7891V12.0059C56.7891 11.2822 56.4746 10.9224 55.8174 10.9224C55.6686 10.9154 55.5201 10.9408 55.3821 10.9966C55.244 11.0524 55.1197 11.1374 55.0175 11.2458C54.9154 11.3542 54.8379 11.4834 54.7904 11.6245C54.7429 11.7657 54.7264 11.9154 54.7422 12.0635V14.6978H53.8535L53.8535 10.1948Z"
        fill="white"
      />
      <path
        d="M59.0937 8.43701H59.9824V14.6978H59.0937V8.43701Z"
        fill="white"
      />
      <path
        d="M61.2178 12.4444C61.1895 12.1484 61.2234 11.8498 61.3172 11.5677C61.4111 11.2857 61.5629 11.0263 61.7628 10.8063C61.9628 10.5863 62.2065 10.4106 62.4784 10.2903C62.7503 10.17 63.0443 10.1079 63.3415 10.1079C63.6388 10.1079 63.9328 10.17 64.2047 10.2903C64.4766 10.4106 64.7203 10.5863 64.9203 10.8063C65.1202 11.0263 65.272 11.2857 65.3659 11.5677C65.4597 11.8498 65.4936 12.1484 65.4653 12.4444C65.4941 12.7406 65.4607 13.0396 65.367 13.3221C65.2734 13.6046 65.1217 13.8644 64.9217 14.0848C64.7217 14.3052 64.4778 14.4814 64.2057 14.6019C63.9335 14.7224 63.6392 14.7847 63.3415 14.7847C63.0439 14.7847 62.7496 14.7224 62.4774 14.6019C62.2053 14.4814 61.9614 14.3052 61.7614 14.0848C61.5614 13.8644 61.4097 13.6046 61.3161 13.3221C61.2224 13.0396 61.189 12.7406 61.2178 12.4444ZM64.5508 12.4444C64.5508 11.4683 64.1123 10.8975 63.3428 10.8975C62.5703 10.8975 62.1358 11.4683 62.1358 12.4444C62.1358 13.4283 62.5703 13.9947 63.3428 13.9947C64.1123 13.9946 64.5508 13.4243 64.5508 12.4444Z"
        fill="white"
      />
      <path
        d="M66.4009 13.4243C66.4009 12.6138 67.0044 12.1465 68.0757 12.0801L69.2954 12.0098V11.6211C69.2954 11.1455 68.981 10.877 68.3735 10.877C67.8774 10.877 67.5337 11.0591 67.4351 11.3775H66.5747C66.6655 10.604 67.3931 10.1079 68.4146 10.1079C69.5435 10.1079 70.1802 10.6699 70.1802 11.6211V14.6978H69.3247V14.065H69.2544C69.1117 14.292 68.9113 14.477 68.6737 14.6012C68.436 14.7254 68.1697 14.7843 67.9019 14.772C67.7128 14.7916 67.5218 14.7715 67.341 14.7128C67.1602 14.6541 66.9938 14.5581 66.8524 14.4312C66.711 14.3042 66.5977 14.149 66.52 13.9756C66.4422 13.8022 66.4016 13.6144 66.4009 13.4243ZM69.2954 13.0396V12.6631L68.1958 12.7334C67.5757 12.7749 67.2944 12.9859 67.2944 13.3828C67.2944 13.7881 67.646 14.0239 68.1294 14.0239C68.2711 14.0383 68.4142 14.024 68.5502 13.9819C68.6862 13.9398 68.8123 13.8708 68.9211 13.7789C69.0299 13.6871 69.1191 13.5743 69.1834 13.4473C69.2477 13.3203 69.2858 13.1816 69.2954 13.0396Z"
        fill="white"
      />
      <path
        d="M71.3481 12.4444C71.3481 11.0215 72.0796 10.1201 73.2173 10.1201C73.4987 10.1072 73.778 10.1746 74.0225 10.3145C74.267 10.4544 74.4667 10.661 74.5981 10.9101H74.6646V8.43701H75.5532V14.6978H74.7017V13.9863H74.6313C74.4897 14.2338 74.2831 14.4378 74.0339 14.5763C73.7846 14.7148 73.5022 14.7825 73.2173 14.772C72.0718 14.772 71.3481 13.8706 71.3481 12.4444ZM72.2661 12.4444C72.2661 13.3994 72.7163 13.9741 73.4693 13.9741C74.2183 13.9741 74.6812 13.3911 74.6812 12.4483C74.6812 11.5098 74.2134 10.9185 73.4693 10.9185C72.7212 10.9185 72.2661 11.4971 72.2661 12.4444Z"
        fill="white"
      />
      <path
        d="M79.23 12.4444C79.2017 12.1484 79.2355 11.8499 79.3294 11.5678C79.4232 11.2857 79.575 11.0264 79.7749 10.8064C79.9748 10.5864 80.2185 10.4107 80.4904 10.2904C80.7622 10.1701 81.0562 10.108 81.3535 10.108C81.6508 10.108 81.9448 10.1701 82.2166 10.2904C82.4885 10.4107 82.7322 10.5864 82.9321 10.8064C83.1321 11.0264 83.2838 11.2857 83.3777 11.5678C83.4715 11.8499 83.5054 12.1484 83.477 12.4444C83.5059 12.7406 83.4724 13.0396 83.3788 13.3221C83.2853 13.6046 83.1336 13.8644 82.9336 14.0848C82.7336 14.3053 82.4897 14.4814 82.2176 14.6019C81.9455 14.7225 81.6511 14.7847 81.3535 14.7847C81.0559 14.7847 80.7616 14.7225 80.4894 14.6019C80.2173 14.4814 79.9734 14.3053 79.7734 14.0848C79.5734 13.8644 79.4218 13.6046 79.3282 13.3221C79.2346 13.0396 79.2011 12.7406 79.23 12.4444ZM82.563 12.4444C82.563 11.4683 82.1245 10.8975 81.355 10.8975C80.5825 10.8975 80.148 11.4683 80.148 12.4444C80.148 13.4283 80.5825 13.9947 81.355 13.9947C82.1245 13.9946 82.563 13.4243 82.563 12.4444Z"
        fill="white"
      />
      <path
        d="M84.6694 10.1948H85.5249V10.9102H85.5913C85.704 10.6532 85.894 10.4379 86.1348 10.2941C86.3757 10.1503 86.6554 10.0852 86.9351 10.1079C87.1542 10.0914 87.3742 10.1245 87.5788 10.2046C87.7833 10.2847 87.9673 10.4098 88.117 10.5706C88.2667 10.7315 88.3783 10.9239 88.4435 11.1337C88.5087 11.3436 88.5258 11.5654 88.4936 11.7827V14.6977H87.605V12.0059C87.605 11.2822 87.2905 10.9224 86.6333 10.9224C86.4845 10.9154 86.336 10.9408 86.198 10.9966C86.0599 11.0524 85.9356 11.1374 85.8335 11.2458C85.7313 11.3542 85.6538 11.4834 85.6063 11.6245C85.5588 11.7657 85.5423 11.9154 85.5581 12.0635V14.6978H84.6694V10.1948Z"
        fill="white"
      />
      <path
        d="M93.5151 9.07374V10.2153H94.4907V10.9639H93.5151V13.2793C93.5151 13.751 93.7095 13.9575 94.1519 13.9575C94.2651 13.9572 94.3783 13.9503 94.4907 13.937V14.6773C94.3311 14.7058 94.1694 14.721 94.0073 14.7227C93.019 14.7227 92.6255 14.375 92.6255 13.5068V10.9638H91.9106V10.2153H92.6255V9.07374H93.5151Z"
        fill="white"
      />
      <path
        d="M95.7046 8.43701H96.5854V10.9185H96.6558C96.7739 10.6591 96.9691 10.4425 97.2148 10.2982C97.4605 10.1539 97.7447 10.0888 98.0288 10.1118C98.2467 10.1 98.4646 10.1364 98.6669 10.2184C98.8692 10.3004 99.0508 10.4261 99.199 10.5864C99.3471 10.7468 99.458 10.9378 99.5238 11.146C99.5896 11.3541 99.6086 11.5742 99.5795 11.7905V14.6978H98.69V12.0098C98.69 11.2905 98.355 10.9263 97.7271 10.9263C97.5743 10.9137 97.4207 10.9347 97.2769 10.9878C97.1332 11.0408 97.0027 11.1247 96.8947 11.2334C96.7867 11.3421 96.7038 11.4732 96.6517 11.6173C96.5997 11.7614 96.5797 11.9152 96.5933 12.0679V14.6977H95.7046L95.7046 8.43701Z"
        fill="white"
      />
      <path
        d="M104.761 13.4819C104.64 13.8935 104.379 14.2495 104.022 14.4876C103.666 14.7258 103.236 14.8309 102.81 14.7847C102.513 14.7925 102.219 14.7357 101.946 14.6182C101.674 14.5006 101.43 14.3252 101.232 14.1041C101.034 13.8829 100.887 13.6214 100.8 13.3376C100.713 13.0537 100.689 12.7544 100.73 12.4605C100.69 12.1656 100.715 11.8656 100.801 11.581C100.888 11.2963 101.034 11.0335 101.231 10.8105C101.428 10.5874 101.671 10.4092 101.942 10.288C102.214 10.1668 102.509 10.1054 102.806 10.1079C104.059 10.1079 104.815 10.9639 104.815 12.3779V12.688H101.635V12.7378C101.621 12.9031 101.642 13.0694 101.696 13.2261C101.75 13.3829 101.837 13.5266 101.95 13.6481C102.062 13.7695 102.199 13.866 102.352 13.9314C102.504 13.9968 102.669 14.0297 102.834 14.0278C103.047 14.0533 103.262 14.0151 103.453 13.9178C103.644 13.8206 103.801 13.6689 103.906 13.4819L104.761 13.4819ZM101.635 12.0308H103.91C103.921 11.8796 103.9 11.7278 103.849 11.5851C103.798 11.4424 103.718 11.3119 103.614 11.2021C103.509 11.0922 103.383 11.0054 103.243 10.9472C103.103 10.8891 102.953 10.8608 102.801 10.8643C102.648 10.8623 102.495 10.8912 102.353 10.9491C102.21 11.0071 102.081 11.0929 101.972 11.2017C101.864 11.3104 101.778 11.4397 101.72 11.5821C101.662 11.7245 101.633 11.8771 101.635 12.0308Z"
        fill="white"
      />
      <path
        d="M24.769 20.3006C24.7797 19.466 25.0014 18.6476 25.4135 17.9216C25.8255 17.1957 26.4145 16.5857 27.1256 16.1486C26.6738 15.5034 26.0779 14.9725 25.385 14.5979C24.6922 14.2234 23.9216 14.0155 23.1344 13.9909C21.4552 13.8146 19.8272 14.9957 18.9715 14.9957C18.0992 14.9957 16.7817 14.0084 15.363 14.0376C14.4453 14.0672 13.551 14.3341 12.7671 14.8121C11.9832 15.2902 11.3365 15.9632 10.8901 16.7654C8.95607 20.1139 10.3987 25.0349 12.2513 27.7415C13.1782 29.0669 14.2615 30.5473 15.6789 30.4948C17.066 30.4373 17.584 29.6103 19.2583 29.6103C20.9171 29.6103 21.4031 30.4948 22.8493 30.4614C24.3377 30.4373 25.2754 29.1302 26.1698 27.7923C26.8358 26.8479 27.3483 25.8042 27.6882 24.6998C26.8235 24.3341 26.0856 23.7219 25.5665 22.9396C25.0474 22.1573 24.77 21.2395 24.769 20.3006Z"
        fill="white"
      />
      <path
        d="M22.0374 12.2108C22.8489 11.2366 23.2487 9.98445 23.1519 8.72021C21.9121 8.85044 20.7668 9.44299 19.9443 10.3798C19.5422 10.8375 19.2342 11.3699 19.0379 11.9467C18.8417 12.5235 18.761 13.1333 18.8006 13.7412C19.4207 13.7476 20.0342 13.6132 20.5949 13.3481C21.1556 13.083 21.6488 12.6942 22.0374 12.2108Z"
        fill="white"
      />
    </svg>
  ),
});

export const GooglePlayIcon = createIcon({
  viewBox: '0 0 135 40',
  path: (
    <svg
      fill="none"
      height="40"
      viewBox="0 0 135 40"
      width="135"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect fill="url(#pattern0_28981_2577)" height="40" width="134.286" />
      <defs>
        <pattern
          height="1"
          id="pattern0_28981_2577"
          patternContentUnits="objectBoundingBox"
          width="1"
        >
          <use
            transform="matrix(0.00177305 0 0 0.00595238 -0.072695 -0.244048)"
            xlinkHref="#image0_28981_2577"
          />
        </pattern>
        <image
          height="250"
          id="image0_28981_2577"
          preserveAspectRatio="none"
          width="646"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
});

export const ExtendedBiddingClock = createIcon({
  viewBox: '0 0 17 16',
  path: (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 17 16"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1702_34167)">
        <path
          d="M8.5 4V8H12.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M8.49967 14.6666C12.1815 14.6666 15.1663 11.6818 15.1663 7.99998C15.1663 4.31808 12.1815 1.33331 8.49967 1.33331C4.81777 1.33331 1.83301 4.31808 1.83301 7.99998C1.83301 11.6818 4.81777 14.6666 8.49967 14.6666Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1702_34167">
          <rect
            fill="white"
            height="16"
            transform="translate(0.5)"
            width="16"
          />
        </clipPath>
      </defs>
    </svg>
  ),
});
